import React, { useContext } from "react";
import ConfigurationContext from "../../../infrastructure/context/configuration/configuration.context";
import TranslationsContext from "../../../infrastructure/context/translations/translations-context";
import TranslationManager from "../../../infrastructure/translation-manager";
import { TranslationsPrefix } from "../../../infrastructure/const";

const ShippingPriceDisclaimer = () => {
  const translationsContext = useContext(TranslationsContext);
  const translationManager = new TranslationManager(translationsContext);
  
  const { getFeatureFlagValue, shippingTypes } =
    useContext(ConfigurationContext);

  const displayDisclaimer = getFeatureFlagValue(
    "displayShippingDisclaimerInCart"
  );

  if (
    !displayDisclaimer ||
    !shippingTypes ||
    !shippingTypes.length ||
    !shippingTypes[0].disclaimer
  ) {
    return null;
  }

  const shippingMethodTranslation = translationManager.getTranslation(
    TranslationsPrefix.Checkout_ShippingTypes + shippingTypes[0].disclaimer
  );

  return (
    <span className="cart-shipping-disclaimer">
      {shippingMethodTranslation}
    </span>
  );
};

export default ShippingPriceDisclaimer;
